export default __webpack_public_path__ + "static/media/pricing_vehicle.cbc26bc1.svg";